module.exports = __webpack_public_path__ + "1548edca60b9a861c6e3bee4032c9578.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/app-page/victory-stories/sam.png
// module id = 1782
// module chunks = 1